module.exports = __webpack_public_path__ + "img/3_Cecum.60db0f05.png";